<script>
import axios from "axios";
import Swal from "sweetalert2";
import Drawer from "@/components/drawer";

// Custom Componentns
import PageHeader from "@/components/page-header";
import superService from "@/helpers/APIService/super.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import { socketConnect } from "@/helpers/webSocketHandler";
import appConfig from "@/app.config";

const API_URL =
  process.env.NODE_ENV == "development"
    ? process.env.VUE_APP_ROOT_API
    : process.env.VUE_APP_ROOT_PRODUCTION_API;

export default {
  page: {
    title: "Kiosk Status",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    PageHeader,
  },
  props: {},
  data() {
    return {
      title: "Kiosk Status",
      kiosk: {
        data: [],
      },
      hotels: [],
      toPathInKiosk: " ~ ",
      avgData: null,
      isBtnLoading: false,
      email: "",
      password: "",
      openStatusDrawer: false,
      kioskCommunication: null,
      isStillLoading: false,
      activeKioskCount: 0,
      inactiveKioskCount: 0,
    };
  },
  mounted() {
    this.getHotels();
    this.getKioskStatus(this.user);
  },
  computed: {
    ...authComputed,
  },
  methods: {
    // Method is used to get hotel list
    async getHotels() {
      try {
        const response = await superService.getHotelsList();
        if (response) {
          response.map((item) => {
            this.hotels.push({ text: item.name, value: item.id });
          });
          localStorage.setItem("hotels", btoa(JSON.stringify(this.hotels)));
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    getKioskStatus(data) {
      this.activeKioskCount = 0;
      this.isStillLoading = true;
      axios
        .get(API_URL + "user/spa/kiosk", {
          headers: {
            Authorization: "Bearer " + data.access,
            "x-timezone": "America/New_York",
          },
        })
        .then((response) => {
          this.isStillLoading = false;
          response.data.map((item) => {
            const connections = this.connectWebSocket(
              `kiosk/video_call_communication/${item.id}?token=${this.user.access}`
            );

            let statusData = {
              ...item,
              connections,
              agent: "Unavailable",
              agent_mode: "Not Connected",
              agent_mic: "Off",
              agent_video: "Off",
              agent_isConnected: false,
              kiosk_mode: "Not Connected",
              kiosk_mic: "Off",
              kiosk_selected_mic: "Not Selected",
              kiosk_video: "Off",
              kiosk_selected_camera: "Not Selected",
            };
            this.kiosk.data.push(statusData);
          });

          this.kiosk.data = this.kiosk.data.map((item) => {
            item.connections.onopen = () => {
              item.agent_isConnected = true;
              item.connections.send(
                JSON.stringify({
                  command: "message",
                  message: "Please send me connection data",
                })
              );
            };
            item.connections.onmessage = (event) => {
              const { command, message, sender } = JSON.parse(event.data);
              if (command == "message") {
                if (sender.user_type !== "super_admin") {
                  if (item.id == message.message.kiosk_id) {
                    if (sender.user_type == "kiosk_machine") {
                      item.kiosk_mode = message.message.kiosk_mode;
                      item.kiosk_mic = message.message.kiosk_mic;
                      item.kiosk_video = message.message.kiosk_video;
                      item.kiosk_selected_mic =
                        message.message.kiosk_selected_mic;
                      item.kiosk_selected_camera =
                        message.message.kiosk_selected_camera;
                    }
                    if (
                      sender.user_type == "hotel_admin" ||
                      sender.user_type == "hotel_staff"
                    ) {
                      item.agent = message.message.agent;
                      item.agent_mode = message.message.mode;
                      item.agent_mic = message.message.agent_mic;
                      item.agent_video = message.message.agent_video;
                    }
                  }
                }
              }
            };
            if (item.agent_mode == "Not Connected") {
              this.inactiveKioskCount += 1;
            } else {
              this.activeKioskCount += 1;
            }
            return item;
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    detailer(data) {
      if (data !== "close") {
        this.openStatusDrawer = !this.openStatusDrawer;
        this.avgData = data;
        this.kioskCommunication = this.connectWebSocket(
          `kiosk/kiosk_communication/${this.avgData.id}?token=${this.user.access}`
        );
        this.kioskCommunication.onmessage = function (event) {
          const { command, message, sender } = JSON.parse(event.data);
          if (sender.user_type !== "super_admin") {
            if (message.message.eventToBeFire) {
              if (message.message.eventToBeFire) {
                this.toPathInKiosk = this.toPathInKiosk;
              } else {
                this.toPathInKiosk = message.message.toPathInKiosk;
              }
            }
          }
        };
      }
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      this.isBtnLoading = true;
      const data = {
        email: this.email,
        password: this.password,
      };
      axios
        .post(API_URL + "auth/login", data, {})
        .then((response) => {
          localStorage.setItem(
            "super_admin_login",
            JSON.stringify(response.data)
          );
          Middleware.notification("Super Admin login successful !!", "success");

          this.$bvModal.hide("super-admin-login-modal");
          this.getKioskStatus(response.data);
          this.isBtnLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    sendLogOut() {
      Swal.fire({
        title: "Continue logging out?",
        text: "This action will log out kiosk!!",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Log out!",
      }).then((result) => {
        if (result.value) {
          this.singleConns[1].send(
            JSON.stringify({
              command: "message",
              message: "Kiosk want to logout",
            })
          );
          Middleware.notification("Successfully logged out !!", "success");
        }
      });
    },
    // Method is use to connect web socket
    connectWebSocket(url) {
      const connection = socketConnect(url);
      connection.onclose = function (event) {
        socketConnect(url);
      };
      connection.onerror = function (error) {
        socketConnect(url);
      };
      return connection;
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />
    <b-card>
      <div class="col-md-12 mb-3">
        <div class="d-flex justify-content-end">
          <span class="me-2"><b>Status :</b></span>
          <div class="d-flex align-items-center">
            <i class="fas fa-circle text-success fs-5 mx-1"></i>
            <p class="mb-0">
              Active (<label class="mb-0 fw-bold">
                {{ activeKioskCount }} </label
              >)
            </p>
          </div>
          <div class="d-flex align-items-center">
            <i class="fas fa-circle text-danger fs-5 mx-1"></i>
            <p class="mb-0">
              Inactive (<label class="mb-0 fw-bold">
                {{ inactiveKioskCount }} </label
              >)
            </p>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th>Kiosk Name</th>
              <th class="text-center">Agent-Mode</th>
              <th class="text-center">Agent-Audio</th>
              <th class="text-center">Agent-Camera</th>

              <th class="text-center">Kiosk-Mode</th>
              <th class="text-center">Kiosk-Audio</th>
              <th class="text-center">Kiosk-Camera</th>
            </tr>
          </thead>
          <tbody v-if="isStillLoading">
            <tr v-for="item in 10" :key="item">
              <td class="placeholder-glow" v-for="no in 7" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr
              v-for="data in kiosk.data"
              :key="data.id"
              @click="detailer(data)"
            >
              <td>
                <i
                  class="fas fa-circle fs-5"
                  :class="
                    data.kiosk_mode == 'Not Connected'
                      ? 'text-danger'
                      : 'text-success'
                  "
                ></i>
                {{ data.user_hotel.name }} - {{ data.user_hotel.city }}
                <i
                  :class="
                    data.agent_isConnected
                      ? 'd-none'
                      : 'mdi mdi-vanish mdi-spin mdi-16px'
                  "
                ></i>
              </td>
              <td class="text-center text-capitalize">
                {{ data.agent_mode }}
              </td>

              <td class="text-center">
                <span v-if="data.agent_mic == 'Denied'">{{
                  data.agent_mic
                }}</span>
                <i
                  v-else
                  :class="
                    data.agent_mic == 'On'
                      ? 'fas fa-microphone'
                      : 'fas fa-microphone-slash'
                  "
                ></i>
              </td>

              <td class="text-center">
                <span v-if="data.agent_video == 'Denied'">{{
                  data.agent_video
                }}</span>
                <i
                  v-else
                  :class="
                    data.agent_video == 'On'
                      ? 'bx bxs-camera'
                      : 'bx bxs-camera-off'
                  "
                ></i>
              </td>

              <td class="text-center text-capitalize">{{ data.kiosk_mode }}</td>

              <td class="text-center">
                <span v-if="data.kiosk_mic == 'Denied'">{{
                  data.kiosk_mic
                }}</span>
                <i
                  v-else
                  :class="
                    data.kiosk_mic == 'On'
                      ? 'fas fa-microphone'
                      : 'fas fa-microphone-slash'
                  "
                ></i>
                <i
                  class="fa fa-info-circle mb-0 ms-1"
                  v-b-popover.hover.top="data.kiosk_selected_mic"
                ></i>
              </td>

              <td class="text-center">
                <span v-if="data.kiosk_video == 'Denied'">{{
                  data.kiosk_video
                }}</span>
                <i
                  v-else
                  :class="
                    data.kiosk_video == 'On'
                      ? 'bx bxs-camera'
                      : 'bx bxs-camera-off'
                  "
                ></i
                ><i
                  class="fa fa-info-circle mb-0 ms-1"
                  v-b-popover.hover.top="data.kiosk_selected_camera"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>

    <!-- status drawer -->

    <Drawer
      @close="detailer()"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="700"
    >
      <div v-if="openStatusDrawer">
        <h4 class="offcanvas-title">
          {{ avgData.user_hotel.name }} - {{ avgData.user_hotel.brand.name }}
        </h4>
        <hr />
        <div class="text-capitalize">
          <div class="col-md-12">
            <div class="d-flex mb-2">
              <h5 class="w-230">Current Agent</h5>
              <span class="mx-2 text-dark">:</span>
              <p class="fs-5 mb-0 text-dark">{{ avgData.agent }}</p>
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex mb-2">
              <h5 class="w-230">Agent Mode Status</h5>
              <span class="mx-2 text-dark">:</span>
              <p class="fs-5 mb-0 text-dark">{{ avgData.agent_mode }}</p>
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex mb-2">
              <h5 class="w-230">Agent Mic Status</h5>
              <span class="mx-2 text-dark">:</span>
              <p class="fs-5 mb-0 text-dark">{{ avgData.agent_mic }}</p>
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex mb-2">
              <h5 class="w-230">Agent Video Status</h5>
              <span class="mx-2 text-dark">:</span>
              <p class="fs-5 mb-0 text-dark">{{ avgData.agent_video }}</p>
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex mb-2">
              <h5 class="w-230">Kiosk Mode Status</h5>
              <span class="mx-2 text-dark">:</span>
              <p class="fs-5 mb-0 text-dark">{{ avgData.kiosk_mode }}</p>
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex mb-2">
              <h5 class="w-230">Kiosk Video Status</h5>
              <span class="mx-2 text-dark">:</span>
              <p class="fs-5 mb-0 text-dark">{{ avgData.kiosk_video }}</p>
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex mb-2">
              <h5 class="w-230">Kiosk Mic Status</h5>
              <span class="mx-2 text-dark">:</span>
              <p class="fs-5 mb-0 text-dark">{{ avgData.kiosk_mic }}</p>
            </div>
          </div>
          <div class="d-flex mb-2">
            <h5 class="w-230">Kiosk Selected Camera</h5>
            <span class="mx-2 text-dark">:</span>
            <p class="fs-5 mb-0 text-dark">
              {{
                avgData.kiosk_selected_camera
                  ? avgData.kiosk_selected_camera
                  : "Not Selected"
              }}
            </p>
          </div>
          <div class="d-flex mb-2">
            <h5 class="w-230">Kiosk Current Path Location</h5>
            <span class="mx-2 text-dark">:</span>
            <p v-if="toPathInKiosk" class="fs-5 mb-0 text-dark">
              {{ toPathInKiosk }}
              {{
                toPathInKiosk.split("/")[1]
                  ? "» " + toPathInKiosk.split("/")[1]
                  : "» ~"
              }}
              {{
                toPathInKiosk.split("/")[2]
                  ? toPathInKiosk.split("/")[2].split("?page=")[0]
                    ? "» " + toPathInKiosk.split("/")[2].split("?page=")[0]
                    : ""
                  : ""
              }}
              {{
                toPathInKiosk.split("/")[2]
                  ? toPathInKiosk.split("/")[2].split("?page=")[1]
                    ? toPathInKiosk
                        .split("/")[2]
                        .split("?page=")[1]
                        .split("&")[0]
                      ? "» " +
                        toPathInKiosk
                          .split("/")[2]
                          .split("?page=")[1]
                          .split("&")[0]
                      : ""
                    : ""
                  : ""
              }}
            </p>
          </div>
          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <h5 class="mb-0">Action</h5>
              <span class="mx-2 text-dark text-dark">:</span>
              <b-button
                type="button"
                variant="primary"
                @click="sendLogOut()"
                :disabled="avgData.kiosk_mode == 'Not Connected'"
              >
                Log Out
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<style scoped>
.w-230 {
  min-width: 230px;
}
</style>
